import gql from 'graphql-tag';

const STUDENT_MODEL = gql`
  query {
    student_model: student {
      skype_name
      rank_id
      level_id
    }
  }
`

const STUDENT_PROFILE = gql`
  query {
    student_profile {
      student_id
      other_setting {
        old_design
      }
    }
  }
`;

const STUDENT_INFO = gql`
query {
    student_info {
      booking_remaining
      ticket_count_info {
        available_normal_ticket_count # 通
        available_free_ticket_count # 振
      }
    }
  }
`;

const STUDENT_BOOKMARK_LIST_ALL = gql`
  query {
    student_bookmark_list_all {
      id
      bookmark_list_name
    }
  }
`;

const STUDENT_ID = gql`
  query {
    student_model: student {
      student_id
    }
  }
`;

const STUDENT_OTHER_SETTING = gql`
  query {
    student_other_setting {
      enable_beta
      user_timezone
    }
  }
`;

export { 
  STUDENT_MODEL, 
  STUDENT_PROFILE, 
  STUDENT_INFO, 
  STUDENT_BOOKMARK_LIST_ALL,
  STUDENT_ID,
  STUDENT_OTHER_SETTING
};
